<template>
  <div>
    <ylHeaderBgMobile v-if="isMobileScreen" v-bind="$attrs" :pageInfo="pageInfoApp" />
    <ylHeaderBgPC v-else v-bind="$attrs" :pageInfo="pageInfo" />
  </div>
</template>
<script>
export default {
  name: "ylHeaderBg",
  components: {
    ylHeaderBgMobile: () => import("./components/mobile.vue"),
    ylHeaderBgPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      pageInfo: {},
      pageInfoApp: {},
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.getPagesBanner();
  },
  methods: {
    async getPagesBanner() {
      const { pageName } = this.$attrs;
      if (!pageName) return;
      try {
        // 获取页面背景图
        const list = await this.$api.pagesBanner();
        // 定义筛选逻辑
        const getPageInfo = (title) => {
          return list.find((item) => item.title === title) || {};
        };
        // 筛选对应的页面信息
        this.pageInfo = getPageInfo(pageName);
        this.pageInfoApp = getPageInfo(`${pageName}-app`);
      } catch (error) {
        console.error(`获取页面背景图: ${error}`);
      }
    },
  },
};
</script>